module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/manage/forgot-password/forgot-password.component.css
// module id = ./src/app/components/manage/forgot-password/forgot-password.component.css
// module chunks = main